module.exports = __webpack_public_path__ + "res/Roboto-BoldItalic-webfont.woff?38d35f09625915e3864769b29d799bda";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldItalic-webfont.woff
// module id = 28
// module chunks = 0